<template lang="pug">
#notation
  .addNotePic(v-show='addpanel')
    .mpic
      .uploadpic(v-for='(item,index) in base64List' :key='index')
        van-image(:src='item.url' alt='点击截图' @click='cutDwg(index)')
        van-icon(v-show='item.hasKss' name='close' @click='delCutPic(index)')
      .right
        van-image.annotationClose(:src="require('@/CommonDP/mongeView/appView/images/pencilClose.png')" alt='关闭' srcset='' @click.stop='closefunc')
        van-image.next(:src="require('@/CommonDP/mongeView/appView/images/next.png')" alt='下一步' srcset @click.stop='nextfunc')
  //- 创建批注
  notationAdd(ref="notationAdd" :type="actionData.type")
</template>

<script>
import iconImage from "@/CommonDP/mongeView/appView/images/icon-cutImg.png";
import kscreenshot from '@/CommonDP/utils/kscreenshot/src/kss.js';
import html2canvas from 'html2canvas';
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import notationAdd from "@/CommonDP/mongeView/appView/question/notationAdd.vue";

export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  components: { notationAdd },
  data () {
    return {
      addpanel: true,
      base64List: [
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false },
        { url: iconImage, hasKss: false }
      ],
      kss: "",
      kissIndex: ''
    };
  },
  computed: {
    filData() {
      return JSON.parse(mongeApp.other.fileInfo);
    }
  },
  methods: {
    closefunc() {
      this.$emit("closeCom", 'issue', false);
    },
    // 截图
    async cutDwg(val) {
      this.kissIndex = val;
      await this.startScreenShot(this.type);
    },
    // 文件截图
    async startScreenShot (index) {
      this.kss = new kscreenshot({
        endCB: (base64) => {
          // 获取的图片
          this.getAddCutPicList(base64, this.kissIndex);
        },
        cancelCB: () => {
        }
      });
      switch (this.type) {
        case 'pdf':
          const pdfBox = this.$parent.$parent.$refs.iframeID;
          pdfBox.contentWindow.postMessage('cut');
          window.cutCallback = (el) => {
            html2canvas(el, { useCORS: true, allowTaint: true }).then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          };
          break;
        case 'txt':
          const txtBox = this.$parent.$parent.$refs.txt;
          html2canvas(txtBox, { useCORS: true })
            .then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          break;
        case 'image':
          const imageBox = this.$parent.$parent.$refs.image;
          html2canvas(imageBox, { useCORS: true })
            .then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          break;
        case 'office':
          const officeBox = this.$parent.$parent.$refs.iframeID;
          const dom = officeBox.src.includes(location.host) ? officeBox?.contentWindow?.document.body : officeBox;
          html2canvas(dom, { useCORS: true })
            .then((canvas) => {
              this.kss.startScreenShot(canvas);
            });
          break;
        default:
          break;
      }
    },
    getAddCutPicList(cutimglist, index) {
      this.base64List[index].url = cutimglist;
      this.base64List[index].hasKss = true;
    },
    async nextfunc() {
      let { isH5 } = this.$route.query || {};
      if (isH5) {
        this.openNotationAdd();
      } else {
        const picList = [];
        for (const index in this.base64List) {
          if (this.base64List[index].hasKss) {
            picList.push(await this.getFileMD5(this.base64List[index].url));
          }
        }
        const { fileId, fileName, prjId, fileVersion: versionIds } = this.filData;
        const { fileType, status, noNeedIssue } = this.$route.query;
        const data = { fileId, fileName, fileType, versionIds, prjId, status, noNeedIssue, source: 'add', picList, autoScreenshotMd5: '' };
        await this.$nextTick();
        await mongeApiMlib.uniPostMessage(data);
      }
      setTimeout(() => {
        this.base64List.forEach(itm => {
          itm.url = iconImage;// 清除截图
          itm.hasKss = false;// 去掉叉号
          this.footType4 = false;// 重置选中状态
        });
        this.addpanel = false;// 关闭截图弹框
      }, 1500);
    },
    async getFileMD5(base64) {
      const blob = this.dataURItoBlob(base64);
      const formData = new FormData();
      formData.set("files", blob);
      const res = await mongeService.picupload(formData);
      if (res.result === "0") {
        return res.data[0];
      }
    },
    dataURItoBlob(base64Data) {
      let byteString;
      if (base64Data.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64Data.split(",")[1]);
      } else {
        byteString = unescape(base64Data.split(",")[1]);
      }
      const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: mimeString });
      return blob;
    },
    // 删除截图
    delCutPic(index) {
      this.base64List[index].url = iconImage;
      this.base64List[index].hasKss = false;
    },

    // 打开创建批注
    openNotationAdd(){
      const { fileId, fileName, fileVersion, prjId } = this.filData;
      const fileList = [{ fileId, fileName, fileVersion }]; // 当前文件
      let picUrlList = [];
      this.base64List.forEach(pic => {
        if(pic.hasKss) picUrlList.push(pic.url);
      });
      const params = {prjId, fileId, fileList, picUrlList};
      this.$refs.notationAdd.open(params);
    },
  }
};
</script>

<style lang="scss" scoped>
.addNotePic{
    position: absolute;
    width: 100%;
    height: 70px;
    bottom: 48px;
    background: #FFFFFF;

    .mpic{
      width: 100%;
      height: 100%;
      padding: 0 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .uploadpic {
        width: 55px;
        height: 55px;
        margin-left: 8px;
        background: rgba(85, 132, 255, 0.1);
        text-align: center;
        position: relative;

        .van-image {
          width: 100%;
          height: 100%;
          display: block;
        }

        .van-icon{
          position: absolute;
          top: 0;
          right: 0;
          font-size: 16px;
          color: #ee0404;
        }

      }

      .uploadpic:first-child{
        margin-left: 0;
      }

      .right{
        margin-left: auto;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        .annotationClose {
          width: 15px;
          height: 15px;
          margin-right: 15px;
        }

        .next {
          color: #fff;
          width: 22px;
          height: 22px;
        }
      }
    }
  }
</style>
